import { createTheme } from "@mui/material";
import type {} from "@mui/x-data-grid/themeAugmentation";

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    tr_text_body: true;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    tr_button_cancel: true;
  }
}

export const appSupportTheme = createTheme({
  palette: {
    primary: {
      main: "#F2F2F2",
      dark: "#BFBFBF",
      contrastText: "#262626",
    },
    secondary: {
      main: "#0D0D0D",
    },
  },
  components: {
    MuiButton: {
      defaultProps: { variant: "contained", size: "small" },

      styleOverrides: {
        root: {
          textTransform: "none",
          height: "2rem",
          fontSize: "0.7vw",
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
      styleOverrides: {
        root: {
          fontSize: "0.7vw",
        },
      },
    },

    MuiRadio: {
      defaultProps: { size: "small", color: "secondary" },
    },
    MuiCheckbox: {
      defaultProps: { color: "secondary", size: "small" },
    },
    MuiTypography: {
      defaultProps: { variant: "tr_text_body" },
      variants: [
        {
          props: { variant: "tr_text_body" },
          style: {
            fontSize: "0.7vw",
          },
        },
        {
          props: { variant: "subtitle1" },
          style: {
            fontSize: "0.9vw",
          },
        },
      ],
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "&& .Mui-selected": {
            backgroundColor: "#BFBFBF",
          },
        },
      },
    },
    MuiSelect:{
      defaultProps:{size:"small"},
      styleOverrides:{
        select:{
          fontSize:"0.7vw"
        },
        
      }
    },
    
    
  },
});
